"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchParamsContext = exports.SearchParamsContextProvider = exports.SearchParamsContext = void 0;
var react_1 = __importStar(require("react"));
exports.SearchParamsContext = (0, react_1.createContext)([
    new URLSearchParams(),
    function () {
        /** noop */
    }
]);
var SearchParamsContextProvider = function (_a) {
    var initialUri = _a.initialUri, children = _a.children;
    var _b = (0, react_1.useState)(initialUri.length !== 0
        ? new URLSearchParams(new URL(initialUri).search)
        : new URLSearchParams()), searchParams = _b[0], setSearchParams = _b[1];
    var setSearchParamsWrapper = function (params) {
        var updatedSearchParams = new URLSearchParams();
        for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value_1 = _b[1];
            updatedSearchParams.set(key, value_1);
        }
        setSearchParams(updatedSearchParams);
    };
    var value = [
        searchParams,
        setSearchParamsWrapper
    ];
    return (react_1.default.createElement(exports.SearchParamsContext.Provider, { value: value }, children));
};
exports.SearchParamsContextProvider = SearchParamsContextProvider;
var useSearchParamsContext = function () {
    return (0, react_1.useContext)(exports.SearchParamsContext);
};
exports.useSearchParamsContext = useSearchParamsContext;
